import { Component, OnInit, ViewChild } from "@angular/core";
import { NgbDropdownConfig, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";
import { AddProductComponent } from "src/app/admin/sub-admin/add-product/add-product.component";
import { ApiResponse } from "src/app/shareModule/models/common.model";
import { AuthServiceService } from "src/app/shareModule/services/auth-service.service";
import { SharedService } from "src/app/shareModule/services/shared.service";
import { environment } from "src/environments/environment";
import { AskComponent } from "../../../marketplace/ask/ask.component";
import { REGION_CATEGORY_IMAGE_LIST } from "../../../marketplace/marketplace.model";
import { RoleService } from "src/app/shareModule/services/roles/role.service";
import { LocalServiceService } from "src/app/shareModule/services/local-service.service";
import { CustomerService } from "src/app/shareModule/services/customer.service";
import { select, Store } from "@ngrx/store";
import { filter, take } from "rxjs";
import { User } from "src/app/shareModule/models/user.model";
import { selectUser } from "src/app/shareModule/states/user-details";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { AppState } from "src/app/shareModule/states/app.state";
import moment from "moment";
import { Tab } from "../my-tabs/my-tabs.component";

@Component({
  selector: "app-loudspeaker-shop",
  templateUrl: "./loudspeaker-shop.component.html",
  styleUrls: ["./loudspeaker-shop.component.scss"],
})
export class LoudspeakerShopComponent implements OnInit {
  @ViewChild("AddShop") addProductComponent: AddProductComponent;
  @ViewChild("Ask") AskComponent: AskComponent;
  public categoriesList: Array<any> = [];
  public regionList = REGION_CATEGORY_IMAGE_LIST;
  public selectedCategoryName = null;
  public selectedSubCategoryName = "";
  public shopExist: boolean = true;
  public shopInfo: any = null;
  public imgUrl = environment.ImageUrl;
  public jobList: Array<any> = [];
  public addedCategoryList: Array<any> = [];
  public addedSubCategoryList: Array<any> = [];
  public selectedRegionForDD = "";
  public selectedCategoryNameForDD = "";
  public selectedCategoryId = null;
  public isPromote: boolean = false;
  public tabs: Array<Tab> = null;
  public form: FormGroup = new FormGroup({
    id: new FormControl(""),
    title: new FormControl("", [Validators.required]),
    description: new FormControl("", [Validators.required]),
    applicationDeadline: new FormControl(new Date(), [Validators.required]),
  });
  public commonModelRef: any;
  public maxDate: string;
  public minDate: any = new Date();
  public searchText: string = '';

  /**
   * Constructor
   */
  constructor(
    private toastr: ToastrService,
    private auth: AuthServiceService,
    config: NgbDropdownConfig,
    private sharedService: SharedService,
    public roleService: RoleService,
    private customerService: CustomerService,
    private local: LocalServiceService,
    private store: Store<AppState>,
    private modalService: NgbModal
  ) {
    // Role *****
    this.roleService.rolesSubject.subscribe((roles) => {
      if (roles) {
        this.tabs = [
          { title: "Ask" },
          { title: "Job", condition: roles && roles?.level.includes("MEMBER_JOB_POSTING") },
          { title: "Support", condition: roles && roles?.level.includes("MEMBER_SHOP_REFERRAL") },
          { title: "Shout Out", condition: roles && roles?.users.includes("MEMBER_JOB_SHOUT") },
        ];
      }
    });
    // Role *****
    config.placement = "top-start";
    config.autoClose = false;
    this._getShopInfo();
    this.getAllProductList();
    this.getJobList();

    const currentDate = moment();
    this.maxDate = currentDate.add(7, "days").format("YYYY-MM-DD");
  }

  ngOnInit(): void {
    this.sharedService.initMarketProfile$.subscribe((params: any) => {
      this.update("productUpdate");
      this.selectMenu(params);
    });
  }
  transformArray(arr) {
    const grouped = arr.reduce((acc, item) => {
      const [category, location] = item.name.split("|");
      if (!acc[category]) {
        acc[category] = [];
      }
      acc[category].push({
        id: item.id,
        keyName: location,
        name: category,
        region: location,
      });
      return acc;
    }, {});

    return Object.keys(grouped).map((key) => ({
      keyName: key,
      sub: grouped[key],
    }));
  }
  public selMenu: any = 0;
  public filterProp = "type";
  public filterValue: any = "shop";

  private _getCategoryList() {
    this.auth.getAllMemberCategorieRelationship().subscribe((response: any) => {
      response.body.map((e) => {
        e.keyName = e.name;
        e.sub = e.subCategory.map((i) => ({
          keyName: i.categoryName,
          ...i,
        }));
      });
      this.categoriesList = response.body;

      this.auth.getAllMemberShopCategory().subscribe((response: any) => {
        // this.categoriesList = response.body;
        this.addedCategoryList = response.body;
        if (this.addedCategoryList.length > 0) {
          this.selectedCategoryName = this.addedCategoryList[0].name;
          this.selectedCategoryNameForDD = this.addedCategoryList[0].name;
          this._getSubCategoryList();
        } else {
          this.selectedCategoryName = this.categoriesList[0].name;
          this.selectedCategoryNameForDD = this.categoriesList[0].name;
        }
      });
      // this._getSubCategoryList();
    });
  }

  updateSelMenu(index: number) {
    this.selectMenu(index);
  }
  public selectMenu(menu: any): void {
    this.selMenu = menu;
    if (this.tabs[menu].title == "Shout Out") {
      this.filterProp = "type";
      this.filterValue = "promote";
      // this.getRecommendProductOfUser();
    } else if (this.tabs[menu].title == "Support") {
      this.getSupportList();

      //write method to get support product
    }
  }

  public openShopProfile() {
    this.addProductComponent.open_shop_info_modal();
  }

  private _getShopInfo() {
    if (this.local.getUser()) {
      this.customerService.getMemberShopsProfile().subscribe(
        (response: ApiResponse) => {
          this.shopExist = response?.message != "Not Exists";
          this.shopInfo = response.body;
          if (this.shopExist) {
            this._getCategoryList();
          }
        },
        ({ error }: any) => { }
      );
    }
  }

  public update(action) {
    if (action == "categoryUpdated") {
      this._getCategoryList();
    } else if (action == "subCategoryUpdated") {
      this._getSubCategoryList();
    } else if (action == "productUpdate") {
      // this._getProductList();
      this.getAllProductList();
    } else {
      this._getShopInfo();
    }
  }

  private _getSubCategoryList(selectedSubCategoryName = "") {
    let selectedCategoryId = this._getSelectedCategoryId(); // Need update
    this.auth
      .getAllMemberShopSubCategory({
        categoryId: selectedCategoryId,
      })
      .subscribe((response: any) => {
        this.addedSubCategoryList = response.body;
        if (this.addedSubCategoryList.length > 0) {
          // this.selectedSubCategoryName = selectedSubCategoryName ? selectedSubCategoryName : "north|yishun";
          this.getProfileCharacterDetails();
          // this._getProductList();
        } else {
          this.selectedSubCategoryName = "";
        }
      });
  }

  public getProfileCharacterDetails() {
    this.store
      .pipe(select(selectUser))
      .pipe(
        filter((user) => !!user),
        take(1)
      )
      .subscribe((resp: User) => {
        if (resp?.regionName) {
          this.selectedSubCategoryName = resp?.regionName ?? "north|yishun";
        }
      });
  }

  public addProduct(type = null) {
    // Validation
    if (this.productAllProductList.filter((i) => i[this.filterProp] == this.filterValue).length >= 3 && !this.roleService?.roles.users.includes("ADMIN_OP")) {
      this.toastr.error("Only Three Product can be added!");
      return;
    }
    // Validation
    this.addProductComponent.isRecommendedProduct = true;
    this.addProductComponent.memberShopProductType = "promote";
    this.addProductComponent.newProduct();
  }

  public openShopAction(action, product: any, cate = "", subcate = ""): void {
    const type = "promote";

    this.selectedCategoryName = cate;
    this.selectedCategoryNameForDD = cate;
    this.selectedSubCategoryName = subcate;
    let selectedCategoryId = this._getSelectedCategoryId();
    let selectedSubCategoryId = this._getSelectedSubCategoryId();
    if (action == "add_category") {
      this.addProductComponent.newTab();
    } else if (action == "add_sub_category") {
      this.addProductComponent.selectedCatId = selectedCategoryId;
      this.addProductComponent.newTab("sub");
    } else if (action == "edit_category") {
      this.addProductComponent.categories = this.categoriesList;
      this.addProductComponent.openEditCatModal();
    } else if (action == "add_product") {
      this.addProduct(type);
    } else if (action == "edit_product" && product?.id) {
      this.addProductComponent.memberShopProductType = type;
      this.addProductComponent.selectedCatId = product?.categoryId;
      this.addProductComponent.selectedCategoryNameForDD = product?.categoryName;
      this.addProductComponent.selectedSubRegionId = product?.subRegionId;

      this.addProductComponent.editProductModal(product?.id);
    } else if (action == "delete_product" && product?.id) {
      this.addProductComponent.delete_food(product?.id);
    }
  }
  private _getSelectedCategoryId(): any {
    return this.addedCategoryList.filter((i: any) => i.name == this.selectedCategoryName)[0]?.id || 0;
  }
  private _getSelectedSubCategoryId(): any {
    return this.addedSubCategoryList.filter((i: any) => i.name == this.selectedSubCategoryName)[0]?.id || 0;
  }
  public onCategoryChange(catId, subCatName): void {
    this.selectedCategoryId = catId;
    this.selectedCategoryNameForDD = subCatName;
    this.selectedCategoryName = subCatName;
    this._getSubCategoryList(subCatName);
  }
  public productAllProductList: Array<any> = [];
  public getAllProductList() {
    this.productAllProductList = [];
    this.customerService
      .getAllShopProduct({
        categoryId: "",
        subCategoryId: "",
      })
      .subscribe(
        (response: any) => {
          this.productAllProductList = response.body;

          this.selMenu ? this.selectMenu(this.selMenu) : "";
        },
        (e) => {
          this.toastr.error(e.error.message);
        }
      );
  }
  public onRegionClick(selected: string) {
    this.selectedRegionForDD = this.selectedRegionForDD == selected ? "" : selected;
  }
  public onSubRegionClick(selected: string) {
    this.selectedSubCategoryName = selected;
  }
  public regionSplit(name: string): string {
    return name && name.includes("|") ? name.split("|")[1] : "";
  }
  public supportOwnerList = [];

  public getSupportList() {
    this.customerService.getUserSupportList().subscribe((resp: ApiResponse) => {
      this.supportOwnerList = resp.body;
      //this.local.getPrimaryImages(this.recommendProductList)
    });
  }

  public deleteSupport(productId: any) {
    this.customerService.deleteMemberSupport(productId).subscribe(
      (resp: ApiResponse) => {
        this.toastr.success(resp.message);
        this.getSupportList();
      },
      ({ error }: any) => {
        this.toastr.error(error.message);
      }
    );
  }

  public onCategoryClick(e, selected: string) {
    e.stopPropagation();
    this.selectedCategoryNameForDD = this.selectedCategoryNameForDD == selected ? "" : selected;
  }

  public openAddPopup(modal: any) {
    if (this.jobList.length >= 1) {
      this.toastr.error("Only One Job can be added!");
      return true;
    }

    this.commonModelRef = this.modalService.open(modal, {
      size: "sm",
      ariaLabelledBy: "modal-basic-title",
      windowClass: "suggestion",
    });
  }

  public deleteJob(id: any): void {
    this.local
      .alertConfirm({
        message: "Are you sure you want to delete this Job Post?",
      })
      .then((res) => {
        if (res.isConfirmed) {
          this.customerService.deleteMemberJobPost(id).subscribe((resp: ApiResponse) => {
            this.toastr.success(resp.message);
            this.getJobList();
          });
        }
      });
  }

  public submitJob(): void {
    if (this.form.valid) {
      this.customerService
        .addMemberJobPost({ title: this.form.get("title").value, description: this.form.get("description").value, applicationDeadline: this.form.get("applicationDeadline").value })
        .subscribe((resp: ApiResponse) => {
          this.form.reset();
          this.commonModelRef.close();
          this.toastr.success(resp.message);
          this.getJobList();
        });
    } else {
      this.toastr.error("Add all require Form data!");
    }
  }

  public getJobList() {
    this.jobList = [];
    this.customerService.getMemberJobPost().subscribe((resp: ApiResponse) => {
      this.jobList = resp.body;
    });
  }
}
